import { render, staticRenderFns } from "./notificationErrorIcon.vue?vue&type=template&id=5a6ab24e&"
import script from "./notificationErrorIcon.vue?vue&type=script&lang=js&"
export * from "./notificationErrorIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports